import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"

import { cn } from "@/lib/utils"

const RadioGroup = React.forwardRef(({ className, ...props }, ref) => {
  return (<RadioGroupPrimitive.Root className={cn("grid gap-2", className)} {...props} ref={ref} />);
})
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

/**
 * A 20px circle with a 10px ink dot: round, where a checkbox is square.
 * The field edge (#8A94A6) when empty, ink when chosen, red when the group
 * is invalid. Arrow keys move and choose (Radix). The hit area reaches 28px;
 * the labelled row is ds/RadioGroup's <Radio>.
 */
const RadioGroupItem = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "peer relative inline-flex aspect-square size-5 shrink-0 items-center justify-center rounded-full border-[1.5px] border-touki-field bg-white",
        "transition-[border-color] duration-fast ease-tk-out",
        "after:absolute after:-inset-1 after:rounded-full after:content-['']",
        "hover:border-touki-black data-[state=checked]:border-touki-black",
        "aria-[invalid=true]:border-touki-red",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}>
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        <span aria-hidden="true" className="block size-2.5 rounded-full bg-touki-dark" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioGroup, RadioGroupItem }
